"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.switchUtilOption = exports.switchUtil = void 0;
var switchUtil = function (k, o) { return o[k]; };
exports.switchUtil = switchUtil;
var switchUtilOption = function (k, o) { return o[k]; };
exports.switchUtilOption = switchUtilOption;
